module.exports = __webpack_public_path__ + "media/images/logos/logo_svg-22a65b685590b92fd67acc81e40399a4.svg";